import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { React, useEffect, useState } from 'react';
import { Container } from '@mui/material';

import BannerImage from '../../assets/customersupport.svg';
//import BannerImage from '../../assets/customersupport.png';
import useMediaQuery from '@mui/material/useMediaQuery';


const BannerImg = () => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>

      <Grid
        container
        paddingTop={3}
        style={{
          height: 600,
          backgroundImage: `url(${BannerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          alignItems: 'center',

        }}
      >
        <Grid item xs={12} sm={6} style={{ marginLeft: isMobile ? '3%' : '6%' }}>
          <Typography

            sx={{
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: '56px',
              lineHeight: '67.77px',
              marginBottom: '3%',
              textAlign: 'left',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
            variant="h4"
          >
            Help and Customer Support
          </Typography>
          <Grid item xs={12} sm={8} >
            <Typography sx={{
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '16px',
              lineHeight: '24px',

            }} >

              We prioritize your satisfaction and are committed to providing exceptional support. If
              you have any questions, concerns, or need assistance, don't hesitate to reach out to us.
              Our dedicated team is readily available, ensuring that you receive the help you need
              promptly and effectively.
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* {isMobile && (
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            textAlign: isMobile ? 'left' : 'left',
            padding: isMobile ? '0 2.5%' : 0,
          }}
        >
          {isMobile && (
            <Grid
              item
              xs={12}
              style={{
                height: '23vh',
                backgroundImage: `url(${BannerImage})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
              }}
            />
          )}
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: isMobile ? '32px' : '56px',
              lineHeight: isMobile ? '40px' : '67.77px',
              marginBottom: '3%',
            }}
            variant="h4"
          >
            Help and Customer Support
          </Typography>
          <Grid
            item
            xs={12}
            sm={8}
            style={{
              margin: isMobile ? '0 auto' : 0,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: isMobile ? '14px' : '16px',
                lineHeight: '24px',
              }}
            >
              We prioritize your satisfaction and are committed to providing exceptional support. If
              you have any questions, concerns, or need assistance, don't hesitate to reach out to us.
              Our dedicated team is readily available, ensuring that you receive the help you need
              promptly and effectively.
            </Typography>
          </Grid>
        </Grid>




      )} */}
    </>
  );
};

export default BannerImg;
